import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { auth } from "@/api/auth";
import { ApiError, setDraftAccount } from "@/api/client";
import type { Account } from "@/api/types";
export const ME_QUERY_KEY = ["studio-auth", "me"] as const;
export function allowedStudio(account: Account): boolean {
  return (
    account.is_active &&
    ["interviewer", "supervisor", "admin"].includes(account.role)
  );
}
export function useCurrentUser() {
  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: async () => {
      try {
        const user = await auth.me();
        setDraftAccount(user.id);
        return user;
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) {
          setDraftAccount(null);
          return null;
        }
        throw error;
      }
    },
    staleTime: 30_000,
    retry: false,
    refetchInterval: 60_000,
  });
}
export function useMfaMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: auth.loginMfa,
    onSuccess: (account) => {
      setDraftAccount(account.id);
      qc.setQueryData(ME_QUERY_KEY, account);
    },
  });
}
